export default __webpack_public_path__ + "static/media/8.f636452a.svg";